import { ListItem, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";

import { useUserData } from "src/context/userContext";

import { ProfileIcon } from "src/components/icons/PersonIcons";
import OpenInNewTabIcon from "src/components/icons/purposed/OpenInNewTabIcon";

export default function GlobalDrawer_KäyttäjäListItem(props) {
  const { user } = useUserData();
  const navigate = useNavigate();
  const fontSize = "26px";
  const onProfileClick = () => {
    props.onClick();
    navigate("/profile");
  };

  return (
    <ListItem disablePadding>
      <ListItemButton onClick={onProfileClick}>
        <ListItemIcon>
          <ProfileIcon style={{ fontSize: fontSize }} />
        </ListItemIcon>
        <ListItemText
          primary={user.personFirstName + " " + user.personLastName}
          secondary={user.personEmail}
        />
        <OpenInNewTabIcon toolTipText={null} />
      </ListItemButton>
    </ListItem>
  );
}

GlobalDrawer_KäyttäjäListItem.propTypes = {
  onClick: PropTypes.func,
};
